/**
 * MP Category Tiles — shuffle + limit when source is "random".
 */
(function () {
  function shuffle(nodes) {
    var i = nodes.length;
    var j;
    var temp;
    while (i > 0) {
      j = Math.floor(Math.random() * i);
      i -= 1;
      temp = nodes[i];
      nodes[i] = nodes[j];
      nodes[j] = temp;
    }
    return nodes;
  }

  function init(root) {
    if (!root || root.getAttribute('data-mp-cat-ready') === '1') return;
    root.setAttribute('data-mp-cat-ready', '1');

    var count = parseInt(root.getAttribute('data-random-count') || '7', 10);
    if (!count || count < 1) count = 7;

    var grid = root.querySelector('.mp-category-tiles__grid');
    if (!grid) return;

    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-mp-category-tile]'));
    if (tiles.length <= count) return;

    shuffle(tiles).forEach(function (tile, index) {
      if (index < count) {
        grid.appendChild(tile);
        tile.hidden = false;
      } else {
        tile.hidden = true;
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-mp-category-tiles]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mp-category-tiles]');
    if (root) {
      root.removeAttribute('data-mp-cat-ready');
      init(root);
    }
  });
})();
